import React from 'react'

export default function experience() {
    return (
      <React.Fragment>
            <section className="resume-section" id="experience">
                <div className="resume-section-content">
                    <h2 className="mb-5">Experience</h2>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Software Developer</h3>
                            <div className="subheading mb-3">Vaaan Infra Private Limited</div>
                           <ul>
                               <li>Prepared enterprise wide web applications and presented projects to clients.</li>
                               <li> Collaborated with cross functional teams to review and analyze system requirements.
                               </li>
                               <li>Utilized the industry tools and technology and studied their implementation affects on project goals.</li>
                               <li>Designed, programmed, tested, and implemented business systems and support client server applications.</li>
                           </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">March 2020 - Present</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Associate Software Developer</h3>
                            <div className="subheading mb-3">Praesidio DoctorPlus Private Limited</div>
                            <li> Providing support to IT personnel in designing, developing,  analyzing, testing, debugging, and executing C# programs for  windows desktop and web-based applications  </li>
                               <li>  Collaborating with other programmers and developers in the  whole development process, and using structured analysis and  design to determine steps to develop programs
                               </li>
                               <li>Determining user requirements, including project budgets and  timelines as well as providing consultative services to clients and  project team members on technical issues  </li>
                               <li> Independently analyzed and validated program specifications as  well as designed and created reliable and reusable C# code that  conformed to department standards and procedures </li>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">January 2018 - Febraury 2020</span></div>
                    </div>
         
                    
                </div>
            </section>
            <hr className="m-0" />
      </React.Fragment>
    )
}
